import React from 'react';
//children
import NavigationList from '../../../../common/NavigationList/';

const StandaloneList = (props) => {
  const {pageJson} = props;
  let list = props.notionalPoolingdata.notionalPooling !== undefined
    ? props.notionalPoolingdata.notionalPooling.poolingStructure.standAloneAccount
    : []

  return (
    <div className="gdoc-np-pool-list-container standalone-list">
        <NavigationList
           history={props.history}
           listtype="caseBodyProductRequests"
           pageReferer="notionalPoolingStandaloneList"
           accounts={props.basicDetailsAccounts}
           productDetailsdata={list}
           addStandaloneEvent={props.editStandaloneEvent}
           deleteStandAloneAccount = {props.deleteStandAloneAccount}
           pageJson ={pageJson}
           lang={props.lang}
        />
    </div>
  );
}

export default StandaloneList;



// WEBPACK FOOTER //
// ./src/components/CaseBody/ProductRequests/CaptureProductGlsNotionalPooling/GlsNotionalPoolingStrucutre/StandaloneList.js